import { render, staticRenderFns } from "./DataCharts.vue?vue&type=template&id=457270b2&scoped=true"
import script from "./DataCharts.vue?vue&type=script&lang=js"
export * from "./DataCharts.vue?vue&type=script&lang=js"
import style0 from "./DataCharts.vue?vue&type=style&index=0&id=457270b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457270b2",
  null
  
)

export default component.exports